/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Impersonation_Start_ErrorInputs */

const vi_impersonation_start_error = /** @type {(inputs: Impersonation_Start_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thể xem với tư cách người dùng này.`)
};

/**

* @param {Impersonation_Start_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const impersonation_start_error = /** @type {((inputs?: Impersonation_Start_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impersonation_Start_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_impersonation_start_error(inputs)
});